import React from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Icon from "../images/circle-arrow-right-solid.svg";

const Hero = () => {
  return (
    <div
      className={`relative flex justify-center flex-wrap bg-white skew-y-6 box-border w-full h-[50vh] pt-14 pb-24 px-3`}
    >
      <div className="absolute self-start left-4 top-24 pt-12 flex flex-col -skew-y-6">
        <a href="" className="reservation mb-4 text-red-500">
          無事終演しました
        </a>
        <AnchorLink offset={180} href="#concert">
          <div className="flex h-9 items-center">
            <img className="w-5 h-5 mr-1" src={Icon} alt="→" />
            <span className="font-bold h-8">演奏会情報</span>
          </div>
        </AnchorLink>
        <AnchorLink offset={180} href="#news">
          <div className="flex h-9 items-center">
            <img className="w-5 h-5 mr-1" src={Icon} alt="→" />
            <span className="font-bold h-8">お知らせ</span>
          </div>
        </AnchorLink>
        <AnchorLink offset={180} href="#about">
          <div className="flex h-9 items-center">
            <img className="w-5 h-5 mr-1" src={Icon} alt="→" />
            <span className="font-bold h-8">ETCについて</span>
          </div>
        </AnchorLink>
        <AnchorLink offset={180} href="#contact">
          <div className="flex h-9 items-center">
            <img className="w-5 h-5 mr-1" src={Icon} alt="→" />
            <span className="font-bold h-8">お問い合わせ</span>
          </div>
        </AnchorLink>
      </div>
    </div>
  );
};

export default Hero;
